<rask-list [data]="filer">
    <rask-list-column header="Vald">
          <ng-template let-row="row">
            <rask-checkbox [(ngModel)]="row.checked">
            </rask-checkbox>
          </ng-template>
        </rask-list-column>
    <rask-list-column header="Namn" field="beteckning"></rask-list-column>
 </rask-list>

<div class="col pb-5 pt-3">
    <div class="d-inline float-end">
    <rask-button color="primary" (click)="save()">Importera</rask-button>
    <rask-button color="secondary" (click)="abort()">Avbryt</rask-button>
    </div>
</div>
